import type { SurveyTimeline, TimelineInterval } from './useSurveyResults';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useClient } from 'hooks/useClient';
import { config } from 'config';
import { fillTimeline } from './survey-timeline';
import { RESULTS_STALE_MS, resultsKey } from './useSurveyResults';

/**
 * Responses over time and the interval they are bucketed by. The chart on screen
 * stays while the other interval loads (keepPreviousData), so switching between
 * days and weeks does not empty the chart and jump the page.
 */
export const useSurveyTimeline = (surveyId: number) => {
  const statsClient = useClient(config.STATISTICS_URL);
  const [interval, setTimelineInterval] = useState<TimelineInterval>('day');

  const { data: timeline } = useQuery<SurveyTimeline>({
    enabled: !!surveyId,
    queryKey: resultsKey(surveyId, 'timeline', interval),
    queryFn: () => statsClient.get<SurveyTimeline>(`/surveys/${surveyId}/timeline?interval=${interval}`),
    staleTime: RESULTS_STALE_MS,
    placeholderData: keepPreviousData,
  });

  // Gaps filled here, so a quiet day is drawn as zero rather than skipped.
  const points = timeline ? fillTimeline({ points: timeline.points, interval: timeline.interval }) : [];

  return { points, interval, setTimelineInterval };
};
